// @generated by protoc-gen-es v2.2.0
// @generated from file hmm/incubator/results_service.proto (package hmm.incubator, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, serviceDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";
import { file_hmm_apis_shared } from "../apis/shared_pb";
import { file_hmm_incubator_results } from "./results_pb";
import { file_hmm_job_job } from "../job/job_pb";

/**
 * Describes the file hmm/incubator/results_service.proto.
 */
export const file_hmm_incubator_results_service = /*@__PURE__*/
  fileDesc("CiNobW0vaW5jdWJhdG9yL3Jlc3VsdHNfc2VydmljZS5wcm90bxINaG1tLmluY3ViYXRvciK1AQoSU3R1ZHlSZXN1bHRzRmlsdGVyEhAKCHN0dWR5X2lkGAEgASgDEhEKCXN1cnZleV9pZBgGIAEoCRIOCgZjdXRfaWQYAiABKAkSFAoMcXVlc3Rpb25faWRzGAMgAygJEhIKCnVud2VpZ2h0ZWQYBCABKAgSLwoIc2lnX3Rlc3QYBSABKA4yHS5obW0uaW5jdWJhdG9yLlJlc3VsdC5TaWdUZXN0Eg8KB2NlbGxfaWQYByABKAMiTQoYQ2VsbFJlc3VsdHNCeUdvYWxSZXF1ZXN0EjEKBmZpbHRlchgBIAEoCzIhLmhtbS5pbmN1YmF0b3IuU3R1ZHlSZXN1bHRzRmlsdGVyInoKGUNlbGxSZXN1bHRzQnlHb2FsUmVzcG9uc2USLAoHcmVzdWx0cxgBIAMoCzIbLmhtbS5pbmN1YmF0b3IuTWV0cmljUmVzdWx0Ei8KCHNpZ190ZXN0GAIgASgOMh0uaG1tLmluY3ViYXRvci5SZXN1bHQuU2lnVGVzdCJPChpDZWxsUmVzdWx0c0J5QW5zd2VyUmVxdWVzdBIxCgZmaWx0ZXIYASABKAsyIS5obW0uaW5jdWJhdG9yLlN0dWR5UmVzdWx0c0ZpbHRlciJ8ChtDZWxsUmVzdWx0c0J5QW5zd2VyUmVzcG9uc2USLAoHcmVzdWx0cxgBIAMoCzIbLmhtbS5pbmN1YmF0b3IuTWV0cmljUmVzdWx0Ei8KCHNpZ190ZXN0GAIgASgOMh0uaG1tLmluY3ViYXRvci5SZXN1bHQuU2lnVGVzdCI4Cg9BcHBlbmRpeFJlcXVlc3QSEAoIc3R1ZHlfaWQYASABKAMSEwoLcXVlc3Rpb25faWQYAiABKAkiQgoQQXBwZW5kaXhSZXNwb25zZRIuCgdyZXN1bHRzGAEgAygLMh0uaG1tLmluY3ViYXRvci5BcHBlbmRpeFJlc3VsdCJOChJEaWFnbm9zdGljc1JlcXVlc3QSEAoIc3R1ZHlfaWQYASABKAMSEQoJY29ob3J0X2lkGAIgASgJEhMKC2FsbF9jb2hvcnRzGAMgASgIImcKE0RpYWdub3N0aWNzUmVzcG9uc2USKwoHcmVzdWx0cxgBIAMoCzIaLmhtbS5pbmN1YmF0b3IuRGlhZ25vc3RpY3MSIwoFbm9ybXMYAiADKAsyFC5obW0uaW5jdWJhdG9yLk5vcm1zIiIKDkRyaXZlcnNSZXF1ZXN0EhAKCHN0dWR5X2lkGAEgASgDIjkKD0RyaXZlcnNSZXNwb25zZRImCgNkYWcYASABKAsyGS5obW0uaW5jdWJhdG9yLkRyaXZlcnNEYWciSAoTU3R1ZHlBbnN3ZXJzUmVxdWVzdBIxCgZmaWx0ZXIYASABKAsyIS5obW0uaW5jdWJhdG9yLlN0dWR5UmVzdWx0c0ZpbHRlciJOChRTdHVkeUFuc3dlcnNSZXNwb25zZRI2Cg9zdWJqZWN0X2Fuc3dlcnMYASABKAsyHS5obW0uaW5jdWJhdG9yLlN1YmplY3RBbnN3ZXJzIkoKGkNyZWF0ZUxpbmthZ2VSZXBvcnRSZXF1ZXN0EiwKBnJlcG9ydBgBIAEoCzIcLmhtbS5pbmN1YmF0b3IuTGlua2FnZVJlcG9ydCJLChtDcmVhdGVMaW5rYWdlUmVwb3J0UmVzcG9uc2USLAoGcmVwb3J0GAEgASgLMhwuaG1tLmluY3ViYXRvci5MaW5rYWdlUmVwb3J0IkoKGlVwZGF0ZUxpbmthZ2VSZXBvcnRSZXF1ZXN0EiwKBnJlcG9ydBgBIAEoCzIcLmhtbS5pbmN1YmF0b3IuTGlua2FnZVJlcG9ydCJLChtVcGRhdGVMaW5rYWdlUmVwb3J0UmVzcG9uc2USLAoGcmVwb3J0GAEgASgLMhwuaG1tLmluY3ViYXRvci5MaW5rYWdlUmVwb3J0Ii0KGUxpc3RMaW5rYWdlUmVwb3J0c1JlcXVlc3QSEAoIc3R1ZHlfaWQYASABKAMiSwoaTGlzdExpbmthZ2VSZXBvcnRzUmVzcG9uc2USLQoHcmVwb3J0cxgBIAMoCzIcLmhtbS5pbmN1YmF0b3IuTGlua2FnZVJlcG9ydCIvChpEZWxldGVMaW5rYWdlUmVwb3J0UmVxdWVzdBIRCglyZXBvcnRfaWQYASABKAkiMAobRGVsZXRlTGlua2FnZVJlcG9ydFJlc3BvbnNlEhEKCXJlcG9ydF9pZBgBIAEoCSIuChpHZXRQcmVkaWN0aW9uUmVzdWx0UmVxdWVzdBIQCghzdHVkeV9pZBgBIAEoAyLvAQobR2V0UHJlZGljdGlvblJlc3VsdFJlc3BvbnNlEhAKCHN0dWR5X2lkGAEgASgDEhoKEnBvc2l0aXZlX3RocmVzaG9sZBgDIAEoAhIaChJuZWdhdGl2ZV90aHJlc2hvbGQYBCABKAISPgoUcHJpbWFyeV9nb2FsX3Jlc3VsdHMYBSADKAsyIC5obW0uaW5jdWJhdG9yLkluY3ViYXRvckFJUmVzdWx0EkAKFnNlY29uZGFyeV9nb2FsX3Jlc3VsdHMYBiADKAsyIC5obW0uaW5jdWJhdG9yLkluY3ViYXRvckFJUmVzdWx0SgQIAhADIjMKH0dldEFJUHJlZGljdGlvblByZUNoZWNrc1JlcXVlc3QSEAoIY2VsbF9pZHMYAiADKAMinQgKIEdldEFJUHJlZGljdGlvblByZUNoZWNrc1Jlc3BvbnNlElEKCnByZV9jaGVja3MYASADKAsyPS5obW0uaW5jdWJhdG9yLkdldEFJUHJlZGljdGlvblByZUNoZWNrc1Jlc3BvbnNlLkNlbGxQcmVDaGVja3MavgEKDlByZUNoZWNrRGV0YWlsEksKCXByZV9jaGVjaxgBIAEoDjI4LmhtbS5pbmN1YmF0b3IuR2V0QUlQcmVkaWN0aW9uUHJlQ2hlY2tzUmVzcG9uc2UuUHJlQ2hlY2sSTgoGc3RhdHVzGAIgASgOMj4uaG1tLmluY3ViYXRvci5HZXRBSVByZWRpY3Rpb25QcmVDaGVja3NSZXNwb25zZS5QcmVDaGVja1N0YXR1cxIPCgdtZXNzYWdlGAMgASgJGnQKDUNlbGxQcmVDaGVja3MSDwoHY2VsbF9pZBgBIAEoAxJSCgpwcmVfY2hlY2tzGAIgAygLMj4uaG1tLmluY3ViYXRvci5HZXRBSVByZWRpY3Rpb25QcmVDaGVja3NSZXNwb25zZS5QcmVDaGVja0RldGFpbCLfAwoIUHJlQ2hlY2sSFQoRUFJFX0NIRUNLX1VOS05PV04QABIuCipQUkVfQ0hFQ0tfQ1JFQVRJVkVfQ0xBU1NJRklDQVRJT05fQ09NUExFVEUQARIfChtQUkVfQ0hFQ0tfRklFTERJTkdfQ09NUExFVEUQAhImCiJQUkVfQ0hFQ0tfUVVBTElUWV9DT05UUk9MX0NPTVBMRVRFEAMSIgoeUFJFX0NIRUNLX1dFSUdIVElOR1NfR0VORVJBVEVEEAQSIwofUFJFX0NIRUNLX0RJQUdOT1NUSUNTX0dFTkVSQVRFRBAFEh8KG1BSRV9DSEVDS19SRVNVTFRTX0dFTkVSQVRFRBAGEi0KKVBSRV9DSEVDS19DT01NRU5UX0NMQVNTSUZJQ0FUSU9OX0NPTVBMRVRFEAcSHwobUFJFX0NIRUNLX0RCVF9TWU5DX0NPTVBMRVRFEAgSIgoeUFJFX0NIRUNLX1BSSU1BUllfQkFTRUxJTkVfU0VUEAkSJAogUFJFX0NIRUNLX1NFQ09OREFSWV9CQVNFTElORV9TRVQQDBInCiNQUkVfQ0hFQ0tfUFJFRElDVElPTl9USFJFU0hPTERTX1NFVBAKEhYKElBSRV9DSEVDS19HT0FMX1NFVBALIowBCg5QcmVDaGVja1N0YXR1cxIcChhQUkVfQ0hFQ0tfU1RBVFVTX1VOS05PV04QABIgChxQUkVfQ0hFQ0tfU1RBVFVTX0lOX1BST0dSRVNTEAESHQoZUFJFX0NIRUNLX1NUQVRVU19DT01QTEVURRACEhsKF1BSRV9DSEVDS19TVEFUVVNfRkFJTEVEEAMiPwoZR2VuZXJhdGVUZXJtUmVwb3J0UmVxdWVzdBIQCghzdHVkeV9pZBgBIAEoAxIQCghwYW5lbF9pZBgCIAEoCSJQChpHZW5lcmF0ZURpYWdub3N0aWNzUmVxdWVzdBIQCghzdHVkeV9pZBgBIAEoAxIgChhwaWxsYXJfd2VpZ2h0aW5nX3ZlcnNpb24YAiABKAkiRQoWR2VuZXJhdGVQaWxsYXJzUmVxdWVzdBIQCghzdHVkeV9pZBgBIAEoAxIZChF3ZWlnaHRpbmdfdmVyc2lvbhgCIAEoCSI0ChdHZW5lcmF0ZVBpbGxhcnNSZXNwb25zZRIZCgNqb2IYASABKAsyDC5obW0uam9iLkpvYiJbChZHZW5lcmF0ZVJlc3VsdHNSZXF1ZXN0EhAKCHN0dWR5X2lkGAEgASgDEi8KCHNpZ190ZXN0GAUgASgOMh0uaG1tLmluY3ViYXRvci5SZXN1bHQuU2lnVGVzdCIqChZHZW5lcmF0ZURyaXZlcnNSZXF1ZXN0EhAKCHN0dWR5X2lkGAEgASgDIjQKF0dlbmVyYXRlRHJpdmVyc1Jlc3BvbnNlEhkKA2pvYhgBIAEoCzIMLmhtbS5qb2IuSm9iIlwKEVNldERyaXZlcnNSZXF1ZXN0EhAKCHN0dWR5X2lkGAEgASgDEg0KBXJwYXJ0GAIgASgJEiYKA2RhZxgDIAEoCzIZLmhtbS5pbmN1YmF0b3IuRHJpdmVyc0RhZyI8ChJTZXREcml2ZXJzUmVzcG9uc2USJgoDZGFnGAEgASgLMhkuaG1tLmluY3ViYXRvci5Ecml2ZXJzRGFnIjcKJEdlbmVyYXRlRGlhZ25vc3RpY3NCZW5jaG1hcmtzUmVxdWVzdBIPCgdvcmdfaWRzGAEgAygJIkIKJUdlbmVyYXRlRGlhZ25vc3RpY3NCZW5jaG1hcmtzUmVzcG9uc2USGQoDam9iGAEgASgLMgwuaG1tLmpvYi5Kb2IiOAobR2VuZXJhdGVEaWFnbm9zdGljc1Jlc3BvbnNlEhkKA2pvYhgBIAEoCzIMLmhtbS5qb2IuSm9iIlMKHlN0b3JlSW5jdWJhdG9yQUlSZXN1bHRzUmVxdWVzdBIxCgdyZXN1bHRzGAEgAygLMiAuaG1tLmluY3ViYXRvci5JbmN1YmF0b3JBSVJlc3VsdCIvCh9TdG9yZUluY3ViYXRvckFJUmVzdWx0c1Jlc3BvbnNlEgwKBGRvbmUYASABKAgiZwoeU2V0QWNjZWxlcmF0b3JCYXNlbGluZXNSZXF1ZXN0EhAKCHN0dWR5X2lkGAEgASgDEhAKCGNlbGxfaWRzGAIgAygDEg8KB2dvYWxfaWQYBCABKAkSEAoIYmFzZWxpbmUYAyABKAIiIQofU2V0QWNjZWxlcmF0b3JCYXNlbGluZXNSZXNwb25zZSJUCh5SdW5BSVByZWRpY3Rpb25Gb3JTdHVkeVJlcXVlc3QSEAoIc3R1ZHlfaWQYASABKAMSIAoYc2tpcF9jbGFzc2lmaWNhdGlvbl93YWl0GAMgASgIIjwKH1J1bkFJUHJlZGljdGlvbkZvclN0dWR5UmVzcG9uc2USGQoDam9iGAEgASgLMgwuaG1tLmpvYi5Kb2IiKgoWRG93bmxvYWRSZXN1bHRzUmVxdWVzdBIQCghzdHVkeV9pZBgBIAEoAyIvChdEb3dubG9hZFJlc3VsdHNSZXNwb25zZRIUCgxkb3dubG9hZF91cmwYAiABKAkyygoKDlJlc3VsdHNTZXJ2aWNlEmgKEUNlbGxSZXN1bHRzQnlHb2FsEicuaG1tLmluY3ViYXRvci5DZWxsUmVzdWx0c0J5R29hbFJlcXVlc3QaKC5obW0uaW5jdWJhdG9yLkNlbGxSZXN1bHRzQnlHb2FsUmVzcG9uc2UiABJuChNDZWxsUmVzdWx0c0J5QW5zd2VyEikuaG1tLmluY3ViYXRvci5DZWxsUmVzdWx0c0J5QW5zd2VyUmVxdWVzdBoqLmhtbS5pbmN1YmF0b3IuQ2VsbFJlc3VsdHNCeUFuc3dlclJlc3BvbnNlIgASTQoIQXBwZW5kaXgSHi5obW0uaW5jdWJhdG9yLkFwcGVuZGl4UmVxdWVzdBofLmhtbS5pbmN1YmF0b3IuQXBwZW5kaXhSZXNwb25zZSIAElYKC0RpYWdub3N0aWNzEiEuaG1tLmluY3ViYXRvci5EaWFnbm9zdGljc1JlcXVlc3QaIi5obW0uaW5jdWJhdG9yLkRpYWdub3N0aWNzUmVzcG9uc2UiABJKCgdEcml2ZXJzEh0uaG1tLmluY3ViYXRvci5Ecml2ZXJzUmVxdWVzdBoeLmhtbS5pbmN1YmF0b3IuRHJpdmVyc1Jlc3BvbnNlIgASWwoMU3R1ZHlBbnN3ZXJzEiIuaG1tLmluY3ViYXRvci5TdHVkeUFuc3dlcnNSZXF1ZXN0GiMuaG1tLmluY3ViYXRvci5TdHVkeUFuc3dlcnNSZXNwb25zZSIAMAESbgoTQ3JlYXRlTGlua2FnZVJlcG9ydBIpLmhtbS5pbmN1YmF0b3IuQ3JlYXRlTGlua2FnZVJlcG9ydFJlcXVlc3QaKi5obW0uaW5jdWJhdG9yLkNyZWF0ZUxpbmthZ2VSZXBvcnRSZXNwb25zZSIAEm4KE1VwZGF0ZUxpbmthZ2VSZXBvcnQSKS5obW0uaW5jdWJhdG9yLlVwZGF0ZUxpbmthZ2VSZXBvcnRSZXF1ZXN0GiouaG1tLmluY3ViYXRvci5VcGRhdGVMaW5rYWdlUmVwb3J0UmVzcG9uc2UiABJrChJMaXN0TGlua2FnZVJlcG9ydHMSKC5obW0uaW5jdWJhdG9yLkxpc3RMaW5rYWdlUmVwb3J0c1JlcXVlc3QaKS5obW0uaW5jdWJhdG9yLkxpc3RMaW5rYWdlUmVwb3J0c1Jlc3BvbnNlIgASbgoTRGVsZXRlTGlua2FnZVJlcG9ydBIpLmhtbS5pbmN1YmF0b3IuRGVsZXRlTGlua2FnZVJlcG9ydFJlcXVlc3QaKi5obW0uaW5jdWJhdG9yLkRlbGV0ZUxpbmthZ2VSZXBvcnRSZXNwb25zZSIAEm4KE0dldFByZWRpY3Rpb25SZXN1bHQSKS5obW0uaW5jdWJhdG9yLkdldFByZWRpY3Rpb25SZXN1bHRSZXF1ZXN0GiouaG1tLmluY3ViYXRvci5HZXRQcmVkaWN0aW9uUmVzdWx0UmVzcG9uc2UiABJiCg9Eb3dubG9hZFJlc3VsdHMSJS5obW0uaW5jdWJhdG9yLkRvd25sb2FkUmVzdWx0c1JlcXVlc3QaJi5obW0uaW5jdWJhdG9yLkRvd25sb2FkUmVzdWx0c1Jlc3BvbnNlIgASfQoYR2V0QUlQcmVkaWN0aW9uUHJlQ2hlY2tzEi4uaG1tLmluY3ViYXRvci5HZXRBSVByZWRpY3Rpb25QcmVDaGVja3NSZXF1ZXN0Gi8uaG1tLmluY3ViYXRvci5HZXRBSVByZWRpY3Rpb25QcmVDaGVja3NSZXNwb25zZSIAMtgHChhSZXN1bHRzR2VuZXJhdGlvblNlcnZpY2USVgoSR2VuZXJhdGVUZXJtUmVwb3J0EiguaG1tLmluY3ViYXRvci5HZW5lcmF0ZVRlcm1SZXBvcnRSZXF1ZXN0GhIuaG1tLmFwaXMuQ1NWQ2h1bmsiADABEm4KE0dlbmVyYXRlRGlhZ25vc3RpY3MSKS5obW0uaW5jdWJhdG9yLkdlbmVyYXRlRGlhZ25vc3RpY3NSZXF1ZXN0GiouaG1tLmluY3ViYXRvci5HZW5lcmF0ZURpYWdub3N0aWNzUmVzcG9uc2UiABJiCg9HZW5lcmF0ZVBpbGxhcnMSJS5obW0uaW5jdWJhdG9yLkdlbmVyYXRlUGlsbGFyc1JlcXVlc3QaJi5obW0uaW5jdWJhdG9yLkdlbmVyYXRlUGlsbGFyc1Jlc3BvbnNlIgASUAoPR2VuZXJhdGVSZXN1bHRzEiUuaG1tLmluY3ViYXRvci5HZW5lcmF0ZVJlc3VsdHNSZXF1ZXN0GhIuaG1tLmFwaXMuUHJvZ3Jlc3MiADABEmIKD0dlbmVyYXRlRHJpdmVycxIlLmhtbS5pbmN1YmF0b3IuR2VuZXJhdGVEcml2ZXJzUmVxdWVzdBomLmhtbS5pbmN1YmF0b3IuR2VuZXJhdGVEcml2ZXJzUmVzcG9uc2UiABJTCgpTZXREcml2ZXJzEiAuaG1tLmluY3ViYXRvci5TZXREcml2ZXJzUmVxdWVzdBohLmhtbS5pbmN1YmF0b3IuU2V0RHJpdmVyc1Jlc3BvbnNlIgASjAEKHUdlbmVyYXRlRGlhZ25vc3RpY3NCZW5jaG1hcmtzEjMuaG1tLmluY3ViYXRvci5HZW5lcmF0ZURpYWdub3N0aWNzQmVuY2htYXJrc1JlcXVlc3QaNC5obW0uaW5jdWJhdG9yLkdlbmVyYXRlRGlhZ25vc3RpY3NCZW5jaG1hcmtzUmVzcG9uc2UiABJ6ChdTZXRBY2NlbGVyYXRvckJhc2VsaW5lcxItLmhtbS5pbmN1YmF0b3IuU2V0QWNjZWxlcmF0b3JCYXNlbGluZXNSZXF1ZXN0Gi4uaG1tLmluY3ViYXRvci5TZXRBY2NlbGVyYXRvckJhc2VsaW5lc1Jlc3BvbnNlIgASegoXUnVuQUlQcmVkaWN0aW9uRm9yU3R1ZHkSLS5obW0uaW5jdWJhdG9yLlJ1bkFJUHJlZGljdGlvbkZvclN0dWR5UmVxdWVzdBouLmhtbS5pbmN1YmF0b3IuUnVuQUlQcmVkaWN0aW9uRm9yU3R1ZHlSZXNwb25zZSIAQjdaNWdpdGh1Yi5jb20vaHVtYW4tbWFkZS1tYWNoaW5lL2htbS9pbmN1YmF0b3I7aW5jdWJhdG9yYgZwcm90bzM", [file_hmm_apis_shared, file_hmm_incubator_results, file_hmm_job_job]);

/**
 * Describes the message hmm.incubator.StudyResultsFilter.
 * Use `create(StudyResultsFilterSchema)` to create a new message.
 */
export const StudyResultsFilterSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 0);

/**
 * Describes the message hmm.incubator.CellResultsByGoalRequest.
 * Use `create(CellResultsByGoalRequestSchema)` to create a new message.
 */
export const CellResultsByGoalRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 1);

/**
 * Describes the message hmm.incubator.CellResultsByGoalResponse.
 * Use `create(CellResultsByGoalResponseSchema)` to create a new message.
 */
export const CellResultsByGoalResponseSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 2);

/**
 * Describes the message hmm.incubator.CellResultsByAnswerRequest.
 * Use `create(CellResultsByAnswerRequestSchema)` to create a new message.
 */
export const CellResultsByAnswerRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 3);

/**
 * Describes the message hmm.incubator.CellResultsByAnswerResponse.
 * Use `create(CellResultsByAnswerResponseSchema)` to create a new message.
 */
export const CellResultsByAnswerResponseSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 4);

/**
 * Describes the message hmm.incubator.AppendixRequest.
 * Use `create(AppendixRequestSchema)` to create a new message.
 */
export const AppendixRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 5);

/**
 * Describes the message hmm.incubator.AppendixResponse.
 * Use `create(AppendixResponseSchema)` to create a new message.
 */
export const AppendixResponseSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 6);

/**
 * Describes the message hmm.incubator.DiagnosticsRequest.
 * Use `create(DiagnosticsRequestSchema)` to create a new message.
 */
export const DiagnosticsRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 7);

/**
 * Describes the message hmm.incubator.DiagnosticsResponse.
 * Use `create(DiagnosticsResponseSchema)` to create a new message.
 */
export const DiagnosticsResponseSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 8);

/**
 * Describes the message hmm.incubator.DriversRequest.
 * Use `create(DriversRequestSchema)` to create a new message.
 */
export const DriversRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 9);

/**
 * Describes the message hmm.incubator.DriversResponse.
 * Use `create(DriversResponseSchema)` to create a new message.
 */
export const DriversResponseSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 10);

/**
 * Describes the message hmm.incubator.StudyAnswersRequest.
 * Use `create(StudyAnswersRequestSchema)` to create a new message.
 */
export const StudyAnswersRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 11);

/**
 * Describes the message hmm.incubator.StudyAnswersResponse.
 * Use `create(StudyAnswersResponseSchema)` to create a new message.
 */
export const StudyAnswersResponseSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 12);

/**
 * Describes the message hmm.incubator.CreateLinkageReportRequest.
 * Use `create(CreateLinkageReportRequestSchema)` to create a new message.
 */
export const CreateLinkageReportRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 13);

/**
 * Describes the message hmm.incubator.CreateLinkageReportResponse.
 * Use `create(CreateLinkageReportResponseSchema)` to create a new message.
 */
export const CreateLinkageReportResponseSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 14);

/**
 * Describes the message hmm.incubator.UpdateLinkageReportRequest.
 * Use `create(UpdateLinkageReportRequestSchema)` to create a new message.
 */
export const UpdateLinkageReportRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 15);

/**
 * Describes the message hmm.incubator.UpdateLinkageReportResponse.
 * Use `create(UpdateLinkageReportResponseSchema)` to create a new message.
 */
export const UpdateLinkageReportResponseSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 16);

/**
 * Describes the message hmm.incubator.ListLinkageReportsRequest.
 * Use `create(ListLinkageReportsRequestSchema)` to create a new message.
 */
export const ListLinkageReportsRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 17);

/**
 * Describes the message hmm.incubator.ListLinkageReportsResponse.
 * Use `create(ListLinkageReportsResponseSchema)` to create a new message.
 */
export const ListLinkageReportsResponseSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 18);

/**
 * Describes the message hmm.incubator.DeleteLinkageReportRequest.
 * Use `create(DeleteLinkageReportRequestSchema)` to create a new message.
 */
export const DeleteLinkageReportRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 19);

/**
 * Describes the message hmm.incubator.DeleteLinkageReportResponse.
 * Use `create(DeleteLinkageReportResponseSchema)` to create a new message.
 */
export const DeleteLinkageReportResponseSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 20);

/**
 * Describes the message hmm.incubator.GetPredictionResultRequest.
 * Use `create(GetPredictionResultRequestSchema)` to create a new message.
 */
export const GetPredictionResultRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 21);

/**
 * Describes the message hmm.incubator.GetPredictionResultResponse.
 * Use `create(GetPredictionResultResponseSchema)` to create a new message.
 */
export const GetPredictionResultResponseSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 22);

/**
 * Describes the message hmm.incubator.GetAIPredictionPreChecksRequest.
 * Use `create(GetAIPredictionPreChecksRequestSchema)` to create a new message.
 */
export const GetAIPredictionPreChecksRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 23);

/**
 * Describes the message hmm.incubator.GetAIPredictionPreChecksResponse.
 * Use `create(GetAIPredictionPreChecksResponseSchema)` to create a new message.
 */
export const GetAIPredictionPreChecksResponseSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 24);

/**
 * Describes the message hmm.incubator.GetAIPredictionPreChecksResponse.PreCheckDetail.
 * Use `create(GetAIPredictionPreChecksResponse_PreCheckDetailSchema)` to create a new message.
 */
export const GetAIPredictionPreChecksResponse_PreCheckDetailSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 24, 0);

/**
 * Describes the message hmm.incubator.GetAIPredictionPreChecksResponse.CellPreChecks.
 * Use `create(GetAIPredictionPreChecksResponse_CellPreChecksSchema)` to create a new message.
 */
export const GetAIPredictionPreChecksResponse_CellPreChecksSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 24, 1);

/**
 * Describes the enum hmm.incubator.GetAIPredictionPreChecksResponse.PreCheck.
 */
export const GetAIPredictionPreChecksResponse_PreCheckSchema = /*@__PURE__*/
  enumDesc(file_hmm_incubator_results_service, 24, 0);

/**
 * PreCheck details what data is being checked for an AI Predict run
 *
 * @generated from enum hmm.incubator.GetAIPredictionPreChecksResponse.PreCheck
 */
export const GetAIPredictionPreChecksResponse_PreCheck = /*@__PURE__*/
  tsEnum(GetAIPredictionPreChecksResponse_PreCheckSchema);

/**
 * Describes the enum hmm.incubator.GetAIPredictionPreChecksResponse.PreCheckStatus.
 */
export const GetAIPredictionPreChecksResponse_PreCheckStatusSchema = /*@__PURE__*/
  enumDesc(file_hmm_incubator_results_service, 24, 1);

/**
 * The status of the PreCheck
 *
 * @generated from enum hmm.incubator.GetAIPredictionPreChecksResponse.PreCheckStatus
 */
export const GetAIPredictionPreChecksResponse_PreCheckStatus = /*@__PURE__*/
  tsEnum(GetAIPredictionPreChecksResponse_PreCheckStatusSchema);

/**
 * Describes the message hmm.incubator.GenerateTermReportRequest.
 * Use `create(GenerateTermReportRequestSchema)` to create a new message.
 */
export const GenerateTermReportRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 25);

/**
 * Describes the message hmm.incubator.GenerateDiagnosticsRequest.
 * Use `create(GenerateDiagnosticsRequestSchema)` to create a new message.
 */
export const GenerateDiagnosticsRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 26);

/**
 * Describes the message hmm.incubator.GeneratePillarsRequest.
 * Use `create(GeneratePillarsRequestSchema)` to create a new message.
 */
export const GeneratePillarsRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 27);

/**
 * Describes the message hmm.incubator.GeneratePillarsResponse.
 * Use `create(GeneratePillarsResponseSchema)` to create a new message.
 */
export const GeneratePillarsResponseSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 28);

/**
 * Describes the message hmm.incubator.GenerateResultsRequest.
 * Use `create(GenerateResultsRequestSchema)` to create a new message.
 */
export const GenerateResultsRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 29);

/**
 * Describes the message hmm.incubator.GenerateDriversRequest.
 * Use `create(GenerateDriversRequestSchema)` to create a new message.
 */
export const GenerateDriversRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 30);

/**
 * Describes the message hmm.incubator.GenerateDriversResponse.
 * Use `create(GenerateDriversResponseSchema)` to create a new message.
 */
export const GenerateDriversResponseSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 31);

/**
 * Describes the message hmm.incubator.SetDriversRequest.
 * Use `create(SetDriversRequestSchema)` to create a new message.
 */
export const SetDriversRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 32);

/**
 * Describes the message hmm.incubator.SetDriversResponse.
 * Use `create(SetDriversResponseSchema)` to create a new message.
 */
export const SetDriversResponseSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 33);

/**
 * Describes the message hmm.incubator.GenerateDiagnosticsBenchmarksRequest.
 * Use `create(GenerateDiagnosticsBenchmarksRequestSchema)` to create a new message.
 */
export const GenerateDiagnosticsBenchmarksRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 34);

/**
 * Describes the message hmm.incubator.GenerateDiagnosticsBenchmarksResponse.
 * Use `create(GenerateDiagnosticsBenchmarksResponseSchema)` to create a new message.
 */
export const GenerateDiagnosticsBenchmarksResponseSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 35);

/**
 * Describes the message hmm.incubator.GenerateDiagnosticsResponse.
 * Use `create(GenerateDiagnosticsResponseSchema)` to create a new message.
 */
export const GenerateDiagnosticsResponseSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 36);

/**
 * Describes the message hmm.incubator.StoreIncubatorAIResultsRequest.
 * Use `create(StoreIncubatorAIResultsRequestSchema)` to create a new message.
 */
export const StoreIncubatorAIResultsRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 37);

/**
 * Describes the message hmm.incubator.StoreIncubatorAIResultsResponse.
 * Use `create(StoreIncubatorAIResultsResponseSchema)` to create a new message.
 */
export const StoreIncubatorAIResultsResponseSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 38);

/**
 * Describes the message hmm.incubator.SetAcceleratorBaselinesRequest.
 * Use `create(SetAcceleratorBaselinesRequestSchema)` to create a new message.
 */
export const SetAcceleratorBaselinesRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 39);

/**
 * Describes the message hmm.incubator.SetAcceleratorBaselinesResponse.
 * Use `create(SetAcceleratorBaselinesResponseSchema)` to create a new message.
 */
export const SetAcceleratorBaselinesResponseSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 40);

/**
 * Describes the message hmm.incubator.RunAIPredictionForStudyRequest.
 * Use `create(RunAIPredictionForStudyRequestSchema)` to create a new message.
 */
export const RunAIPredictionForStudyRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 41);

/**
 * Describes the message hmm.incubator.RunAIPredictionForStudyResponse.
 * Use `create(RunAIPredictionForStudyResponseSchema)` to create a new message.
 */
export const RunAIPredictionForStudyResponseSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 42);

/**
 * Describes the message hmm.incubator.DownloadResultsRequest.
 * Use `create(DownloadResultsRequestSchema)` to create a new message.
 */
export const DownloadResultsRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 43);

/**
 * Describes the message hmm.incubator.DownloadResultsResponse.
 * Use `create(DownloadResultsResponseSchema)` to create a new message.
 */
export const DownloadResultsResponseSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results_service, 44);

/**
 * ResultsSerivce provides incubator study results.
 *
 * @generated from service hmm.incubator.ResultsService
 */
export const ResultsService = /*@__PURE__*/
  serviceDesc(file_hmm_incubator_results_service, 0);

/**
 * ResultsGenerationService generates incubator results.
 *
 * @generated from service hmm.incubator.ResultsGenerationService
 */
export const ResultsGenerationService = /*@__PURE__*/
  serviceDesc(file_hmm_incubator_results_service, 1);

